// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3hHNM","inputDescription":"styles_inputDescription__qY9fm"};